import { useState } from 'react';
import { Modal, Button } from 'antd';
import InputItem from '../../components/InputItem';

export default function DropPlayerOut({ open, onCancel, onConfirm, player }) {
  const [reason, setReason] = useState('');
  return (
    <Modal open={open} onCancel={onCancel} footer={null}>
      <div className="space-y-6">
        <h2>选手名称：{player.name}</h2>
        <InputItem
          require
          label="退赛原因"
          value={reason}
          onChange={setReason}
        />
        <div className="flex flex-col gap-2">
          <Button key="submit" type="primary" onClick={() => onConfirm(reason)}>
            确认
          </Button>
        </div>
      </div>
    </Modal>
  );
}
